<template>
  <div class="classRecord">
    <div class="classRecordDiv">
      <div class="classTitle">
        <Title text="学习记录" />
      </div>
      <div class="classTab">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="听课记录" name="classRecord">
            <Listen />
          </el-tab-pane>
          <el-tab-pane label="做题记录" name="problemRecord"
            ><Problem
          /></el-tab-pane>
          <el-tab-pane label="易错题集" name="errorRecord"
            ><ErrorProblem
          /></el-tab-pane>
          <el-tab-pane label="我的收藏" name="myCollect"
            ><Collect
          /></el-tab-pane>
          <el-tab-pane label="我的笔记" name="myNotes"><Notes /></el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Listen from "./calssModule/listen";
import Problem from "./calssModule/problem";
import ErrorProblem from "./calssModule/errorProblem";
import Collect from "./calssModule/collect";
import Notes from "./calssModule/notes";
export default {
  name: "classRecord",
  data() {
    return {
      activeName: "classRecord",
    };
  },
  watch: {
    $route(val) {
      this.activeName = val.name;
    },
  },
  created() {
    const routeName = this.$route.name;
    if (routeName) {
      this.activeName = routeName;
    }
  },
  components: {
    Listen,
    Problem,
    ErrorProblem,
    Collect,
    Notes,
  },
  methods: {
    handleClick(tab) {
      this.$store.commit("common/changeMenuMutation", {
        name: tab.label,
      });

      this.$router.replace({
        name: tab.name,
      });
      // console.log(tab, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.classRecord {
  min-height: $contentH;
  padding: 20px 20px 0 20px;
}
.classRecord .classRecordDiv {
  width: 100%;
  min-height: inherit;
  background-color: #fff;
}
.classRecord .classRecordDiv .classTitle {
  margin-left: 20px;
}
.classRecord .classRecordDiv .classTab {
  padding: 0 20px;
}
</style>
